// function is_touch_device() {
//     var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
//     var mq = function(query) {
//       return window.matchMedia(query).matches;
//     }

//     if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
//       return true;
//     }

//     // include the 'heartz' as a way to have a non matching MQ to help terminate the join
//     // https://git.io/vznFH
//     var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
//     return mq(query);
// }

module.exports.cumulativeOffset = function(element) {
	var top = 0,
		left = 0;
	do {
		top += element.offsetTop || 0;
		left += element.offsetLeft || 0;
		element = element.offsetParent;
	} while (element);

	return {
		top: top,
		left: left,
	};
};

module.exports.rgbToHsl = rgb => {
	// strip the leading # if it's there
	rgb = rgb.replace(/^\s*#|\s*$/g, '');

	// convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
	if (rgb.length == 3) {
		rgb = rgb.replace(/(.)/g, '$1$1');
	}

	var r = parseInt(rgb.substr(0, 2), 16) / 255,
		g = parseInt(rgb.substr(2, 2), 16) / 255,
		b = parseInt(rgb.substr(4, 2), 16) / 255,
		cMax = Math.max(r, g, b),
		cMin = Math.min(r, g, b),
		delta = cMax - cMin,
		l = (cMax + cMin) / 2,
		h = 0,
		s = 0;

	if (delta == 0) {
		h = 0;
	} else if (cMax == r) {
		h = 60 * (((g - b) / delta) % 6);
	} else if (cMax == g) {
		h = 60 * ((b - r) / delta + 2);
	} else {
		h = 60 * ((r - g) / delta + 4);
	}

	if (delta == 0) {
		s = 0;
	} else {
		s = delta / (1 - Math.abs(2 * l - 1));
	}

	return {
		h: h,
		s: s,
		l: l,
	};
};

module.exports.hexToRgb = hex => {
	if (hex.charAt(0) === '#') {
		hex = hex.substr(1);
	}
	if (hex.length < 2 || hex.length > 6) {
		return false;
	}
	var values = hex.split(''),
		r,
		g,
		b;

	if (hex.length === 2) {
		r = parseInt(values[0].toString() + values[1].toString(), 16);
		g = r;
		b = r;
	} else if (hex.length === 3) {
		r = parseInt(values[0].toString() + values[0].toString(), 16);
		g = parseInt(values[1].toString() + values[1].toString(), 16);
		b = parseInt(values[2].toString() + values[2].toString(), 16);
	} else if (hex.length === 6) {
		r = parseInt(values[0].toString() + values[1].toString(), 16);
		g = parseInt(values[2].toString() + values[3].toString(), 16);
		b = parseInt(values[4].toString() + values[5].toString(), 16);
	} else {
		return false;
	}
	return { r: r, g: g, b: b };
};
